import ContentLoader from "react-content-loader";
import coreFunctions from "src/common/utils/coreFunctions";

const DefaultLoader = () => {
  return (
    <ContentLoader
      viewBox="0 0 400 180"
      height={coreFunctions.isMobileDevice() ? 500 : 180}
      width="100%"
      style={{ width: "100%", height: "auto" }}
    >
      <defs>
        <linearGradient id="custom-gradient">
          <stop offset="0%" stopColor="#f3f3f3">
            <animate
              attributeName="offset"
              values="-2; 1"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="50%" stopColor="#ecebeb">
            <animate
              attributeName="offset"
              values="-1.5; 1.5"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
          <stop offset="100%" stopColor="#f3f3f3">
            <animate
              attributeName="offset"
              values="-1; 2"
              dur="2s"
              repeatCount="indefinite"
            />
          </stop>
        </linearGradient>
      </defs>

      {/* Image */}
      <rect
        x="0"
        y="0"
        rx="10"
        ry="10"
        width="100%"
        height="100"
        fill="url(#custom-gradient)"
      />
      {/* Title */}
      <rect
        x="0"
        y="110"
        rx="4"
        ry="4"
        width="70%"
        height="12"
        fill="url(#custom-gradient)"
      />
      {/* Subtitle */}
      <rect
        x="0"
        y="135"
        rx="3"
        ry="3"
        width="50%"
        height="10"
        fill="url(#custom-gradient)"
      />
      {/* Button */}
      <rect
        x="0"
        y="160"
        rx="5"
        ry="5"
        width="30%"
        height="12"
        fill="url(#custom-gradient)"
      />
    </ContentLoader>
  );
};

export default DefaultLoader;
